import Typography from '@mui/material/Typography';
import getConfig from '@utils/runtimeConfig';

const EnvironmentInformation = () => {
  const { appEnv, apiBaseUri } = getConfig();

  if (appEnv === 'production') {
    return null;
  }

  return (
    <Typography variant="body2">
      Environment: {appEnv}, API: {apiBaseUri}
    </Typography>
  );
};

export default EnvironmentInformation;
